import { render, staticRenderFns } from "./document-issue-mark.vue?vue&type=template&id=019b28f0&"
import script from "./document-issue-mark.vue?vue&type=script&lang=js&"
export * from "./document-issue-mark.vue?vue&type=script&lang=js&"
import style0 from "./document-issue-mark.vue?vue&type=style&index=0&id=019b28f0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('019b28f0')) {
      api.createRecord('019b28f0', component.options)
    } else {
      api.reload('019b28f0', component.options)
    }
    module.hot.accept("./document-issue-mark.vue?vue&type=template&id=019b28f0&", function () {
      api.rerender('019b28f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/documents/document-issue-mark.vue"
export default component.exports